import Masonry from "masonry-layout";

const postGrid = document.querySelector('.archive-post-grid')
let msnry = null;
if ( postGrid ) {
  msnry = new Masonry(postGrid, {
    // options
    itemSelector: 'article',
    columnWidth: '.grid-sizer',
    gutter: '.gutter-sizer',
    percentPosition: true,
    horizontalOrder: true,
  });
}
export {msnry}
